<script setup lang="ts">
import BasePopoverItem from "./BasePopoverItem.vue";
import HandUpIcon20x20 from "../../../icons/popovers/HandUpIcon20x20.vue";
import HandDownIcon20x20 from "../../../icons/popovers/HandDownIcon20x20.vue";
import {
  selfHandUpState,
  selfHandUpToggle,
} from "../../../../states/handUpState";
import { locale } from "../../../../locale";
const props = defineProps<{
  close: () => void;
}>();
const handUpAction = () => {
  selfHandUpToggle();
  props.close();
};
</script>
<template>
  <BasePopoverItem
    :text="selfHandUpState ? locale.tooltips.handdown : locale.tooltips.handup"
    @click.stop="handUpAction"
  >
    <HandDownIcon20x20 v-if="selfHandUpState" />
    <HandUpIcon20x20 v-else />
  </BasePopoverItem>
</template>
